import { message } from 'antd'
import { ReportsApi } from '../../../../api/Corporates/Reports'
import Report from '../../../../components/Corporate/Analytics/Reports/Report'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import { get } from 'lodash'
import { checkForm } from '../../../../modules/Utils'
import React, { useState } from 'react'

function ReportCont(props) {
  const reportType = props.match.params.key
  const formRef = React.createRef()
  const [submitting, setSubmitting] = useState(false)
  const [data, setData] = useState([])

  const { visible, onShow, onCancel } = useModalShow()
  const [list, setList] = useState([])
  const [type, setType] = useState('')

  async function submit() {
    const newObject = await checkForm(formRef)
    console.log(newObject)
    setSubmitting(true)
    try {
      const data = await ReportsApi.analytics(reportType, newObject)
      setSubmitting(false)
      setData(data)
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      setSubmitting(false)
    }
  }

  function onClickNum(accessor, type, readyDate) {
    setList(readyDate || get(data, accessor, []))
    setType(type)
    onShow()
  }

  const propsProps = {
    reportType,
    submit,
    formRef,
    submitting,
    data,
    setSubmitting,
    visible,
    onShow,
    onCancel,
    list,
    setList,
    type,
    setType,
    onClickNum,
  }

  return <Report {...propsProps} />
}

ReportCont.propTypes = {}
ReportCont.defaultProps = {}

export default ReportCont
